export const GIF_URL = "https://api.giphy.com/v1/gifs";
export const API_KEY = "api_key=SiEQZoarEAlZ5lMp5UNXFp8a2qr0LVQo";
